/* tslint:disable */
/* eslint-disable */
/* @relayHash e98a82810a7c90e6f5752677dc0ef94d */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MoreProjectsContainerQueryVariables = {
    firmId: number;
};
export type MoreProjectsContainerQueryResponse = {
    readonly viewer: {
        readonly tradeFirm: {
            readonly " $fragmentRefs": FragmentRefs<"MoreProjects_tradeFirm">;
        } | null;
    };
};
export type MoreProjectsContainerQuery = {
    readonly response: MoreProjectsContainerQueryResponse;
    readonly variables: MoreProjectsContainerQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "firmId",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "firmId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MoreProjectsContainerQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "MoreProjects_tradeFirm",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MoreProjectsContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "designProjectsCover",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DesignProjectCover",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "serviceId",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "coverPhoto",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "url",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              (v3/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "MoreProjectsContainerQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/MoreProjectsContainerQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '7be16adc2ea2e9843a0cbbfcf4a9391a';
export default node;
